import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    const { pathname, hash } = location;

    if (pathname !== "/") {
      return;
    }

    if (!hash || hash === "#" || hash === "#home") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const id = hash.replace("#", "");
    const targetId = (id === "portfolio" || id === "work") ? "work" : id;

    let attempts = 0;
    const maxAttempts = 15;

    const tryScroll = () => {
      const element = document.getElementById(targetId) || document.getElementById(id);

      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }

      attempts += 1;
      if (attempts < maxAttempts) {
        window.setTimeout(tryScroll, 100);
      }
    };

    tryScroll();
  }, [location]);

  return null;
};

export default ScrollToHash;
